import { Component, Input } from '@angular/core';
import {
    LayoutHeaderContextMenuItem,
    LayoutHeaderContextSubMenuItem,
} from './layout-header-toolbar.service';

@Component({
    selector: 'header-context-menu-item',
    standalone: false,
    template: `
        <ng-container *ngIf="item.submenu?.length; else actionButton">
            <button
                mat-icon-button
                type="button"
                [disabled]="item.disabled"
                [matMenuTriggerFor]="submenu"
                [matTooltip]="item.label"
                matTooltipPosition="above"
                [attr.aria-label]="item.label">
                <mat-icon>{{ item.icon }}</mat-icon>
            </button>
            <mat-menu #submenu="matMenu" yPosition="above" xPosition="before">
                <button
                    mat-menu-item
                    type="button"
                    *ngFor="let sub of item.submenu"
                    (click)="runSubmenuAction(sub)">
                    <span class="flex items-center gap-2 w-full">
                        <span
                            *ngIf="sub.chipClass"
                            class="mailing-label-chip py-0.5 px-2.5 rounded-full text-sm font-medium whitespace-nowrap"
                            [ngClass]="sub.chipClass">
                            {{ sub.label }}
                        </span>
                        <span *ngIf="!sub.chipClass">{{ sub.label }}</span>
                        <mat-checkbox
                            class="ml-auto"
                            [checked]="sub.checked"
                            [disableRipple]="true"
                            (click)="$event.stopPropagation()"
                            (change)="runSubmenuAction(sub)">
                        </mat-checkbox>
                    </span>
                </button>
            </mat-menu>
        </ng-container>
        <ng-template #actionButton>
            <button
                mat-icon-button
                type="button"
                [color]="item.active ? item.color : undefined"
                [disabled]="item.disabled"
                [matTooltip]="item.label"
                matTooltipPosition="above"
                [attr.aria-label]="item.label"
                (click)="runAction()">
                <mat-icon>{{ item.icon }}</mat-icon>
            </button>
        </ng-template>
    `,
})
export class HeaderContextMenuItemComponent {
    @Input({ required: true }) item!: LayoutHeaderContextMenuItem;

    runAction(): void {
        if (this.item.disabled || !this.item.handler) {
            return;
        }

        this.item.handler();
    }

    runSubmenuAction(sub: LayoutHeaderContextSubMenuItem): void {
        sub.handler();
    }
}
